// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import IntroSequence from "../prefabs/IntroSequence";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnAudio from "../core/prefabs/BtnAudio";
import BtnSkip from "../prefabs/BtnSkip";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { TransitionPoint } from '../rooting';
import UIButton from '../core/components/UIButton';
/* END-USER-IMPORTS */

export default class Intro extends BaseScene {

  constructor() {
    super("Intro");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // sky
    const sky = this.add.image(960, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_19
    this.add.image(50, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_18
    this.add.image(150, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_17
    this.add.image(250, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_16
    this.add.image(350, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_15
    this.add.image(450, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_14
    this.add.image(550, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_13
    this.add.image(650, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_12
    this.add.image(750, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_11
    this.add.image(850, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_10
    this.add.image(950, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_9
    this.add.image(1050, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_8
    this.add.image(1150, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_7
    this.add.image(1250, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_6
    this.add.image(1350, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_5
    this.add.image(1450, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_4
    this.add.image(1550, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_3
    this.add.image(1650, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_2
    this.add.image(1750, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg_1
    this.add.image(1850, 384, "game-all", "bg-sky.jpg");

    // bg_sky_jpg
    this.add.image(1950, 384, "game-all", "bg-sky.jpg");

    // clouds
    const clouds = this.add.container(960, 384);

    // tile_clouds_1_png
    const tile_clouds_1_png = this.add.image(-526, 46, "game-all", "tile-clouds-1.png");
    clouds.add(tile_clouds_1_png);

    // tile_clouds_2_png
    const tile_clouds_2_png = this.add.image(595, -67, "game-all", "tile-clouds-2.png");
    clouds.add(tile_clouds_2_png);

    // sea
    const sea = this.add.image(960, 725, "game-all", "tile-sea.png");

    // introSequence
    const introSequence = new IntroSequence(this, 960, 384);
    this.add.existing(introSequence);

    // btnBack
    const btnBack = new BtnBack(this, 72, 76);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1854, 76);
    this.add.existing(btnAudio);

    // btnSkip
    const btnSkip = new BtnSkip(this, 1827.5, 671.5);
    this.add.existing(btnSkip);

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // btnSkip (components)
    const btnSkipUIPositionContainer = new UIPositionContainer(btnSkip);
    btnSkipUIPositionContainer.offsetX = 24;
    btnSkipUIPositionContainer.offsetY = 24;
    btnSkipUIPositionContainer.PinRight = true;
    btnSkipUIPositionContainer.PinToBottom = true;

    this.sky = sky;
    this.clouds = clouds;
    this.tile_clouds_1_png = tile_clouds_1_png;
    this.tile_clouds_2_png = tile_clouds_2_png;
    this.sea = sea;
    this.introSequence = introSequence;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.btnSkip = btnSkip;

    this.events.emit("scene-awake");
  }

  private sky!: Phaser.GameObjects.Image;
  private clouds!: Phaser.GameObjects.Container;
  private tile_clouds_1_png!: Phaser.GameObjects.Image;
  private tile_clouds_2_png!: Phaser.GameObjects.Image;
  private sea!: Phaser.GameObjects.Image;
  private introSequence!: IntroSequence;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private btnSkip!: BtnSkip;

  /* START-USER-CODE */

  // Write your code here

  public create() {
    this.editorCreate();

    this.btnBack.on(UIButton.events.clicked, this.back, this);
    this.btnSkip.on(UIButton.events.clicked, this.onIntroSequenceFinished, this);
    this.btnSkip.scale = 0;
    this.introSequence.on(IntroSequence.events.SequenceFinished, this.onIntroSequenceFinished, this);


    this.zoomIn();
  }

  protected zoomIn(){
    this.sea.scale = 1.5;
    let sy = this.sea.y;
    this.sea.y+=50;
    this.add.tween({
      targets: this.sea,
      scale:1,
      y:sy,
      duration: 3300,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0
    });

    this.clouds.scale = 1.3;
    this.add.tween({
      targets: this.clouds,
      scale:1,
      duration: 3200,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0,
    });

    this.sky.scale = 1.3;
    this.add.tween({
      targets: this.sky,
      scale:1,
      duration: 3100,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: 0,
    });

    this.time.addEvent({ delay: 1200, callback: this.startStory, callbackScope: this });
  }

  protected startStory(){

    this.add.tween({
      targets: this.btnSkip,
      scaleX: 1,
      scaleY: 1,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay:600
    });

    this.add.tween({
      targets: this.clouds,
      scaleX: 1.05,
      scaleY: 1.05,
      duration: 3000,
      ease: Phaser.Math.Easing.Cubic.InOut,
      loop: -1,
      yoyo: true
    });
    this.introSequence.showStory();
  }

  protected back() {
    app.gotoNextScene(this, TransitionPoint.IntroBack);
  }

  protected onIntroSequenceFinished() {
    app.gotoNextScene(this, TransitionPoint.IntroEnd);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
